import { Camera } from 'domain/camera'
import { CameraCapability } from 'enums/camera-capability'

/** G3 é o modelo combo (placa + pessoa) — manda pro ANPR por padrão, que é o
 *  caso de uso mais comum pra esse tipo de câmera na base de clientes atual. */
export const eventsRouteForCamera = (camera: Pick<Camera, 'model'>): string =>
  camera.model?.capabilities === CameraCapability.AHCR ? '/ahcr-events' : '/anpr-events'
